export default "__VITE_ASSET__DC8iapuu__"